import React from 'react'

import { Checkin, PnrSorgu } from '@enuygun/icons'

import CheckReservationDialog from './CheckReservationDialog'

export const ManageMyBookingWingieData = {
  en: [
    {
      heading: 'Online check-in',
      subheading: 'Check-in online before arriving at the airport. ',
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: 'Manage your bookings',
      subheading: 'View your itineraries or cancel a booking.',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  de: [
    {
      heading: 'Online-Check-in',
      subheading: 'Online einchecken, bevor Sie am Flughafen ankommen.',
      icon: <Checkin width={40} height={40} />,
      src: '/flug/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: 'Ihre Buchungen verwalten',
      subheading: 'Ihre Reiserouten anzeigen oder eine Buchung stornieren.',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  es: [
    {
      heading: 'Check-in en línea',
      subheading: 'Realiza el check-in en línea antes de llegar al aeropuerto.',
      icon: <Checkin width={40} height={40} />,
      src: '/vuelos/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: 'Administra tus reservas',
      subheading: 'Ve tus itinerarios o cancela una reserva.',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  it: [
    {
      heading: 'Check-in online',
      subheading: 'Effettua il check-in online prima di arrivare in aeroporto.',
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: 'Gestisci le tue prenotazioni',
      subheading: 'Visualizza i tuoi itinerari o cancella una prenotazione.',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  ar: [
    {
      heading: 'إتمام إجراءات السفر',
      subheading: 'أكمل إجراءات السفر عبر الإنترنت قبل وصولك إلى المطار.',
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: 'إدارة حجوزاتك',
      subheading: 'اعرض مسار رحلتك أو قم بإلغاء حجزك.',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  ru: [
    {
      heading: 'Онлайн регистрация',
      subheading: 'Онлайн-регистрация до прибытия в аэропорт.',
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: 'Управляйте своими бронированиями',
      subheading: 'Просмотрите свои маршруты или отмените бронирование.',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  az: [
    {
      heading: 'Onlayn qeydiyyat',
      subheading: 'Hava limanına gəlməzdən əvvəl onlayn qeydiyyatdan keçin.',
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: 'Rezervasiyalarınızı idarə edin',
      subheading: 'Marşrutlarınıza baxın və ya rezervasiyanızı ləğv edin.',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  fr: [
    {
      heading: 'Enregistrement en ligne',
      subheading: "Enregistrez-vous en ligne avant d'arriver à l'aéroport.",
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: 'Gérer vos réservations',
      subheading: 'Consultez vos itinéraires ou annulez une réservation.',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  pt: [
    {
      heading: 'Check-in online',
      subheading: 'Faça o check-in online antes de chegar ao aeroporto.',
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: 'Gerencie suas reservas',
      subheading: 'Visualize seus itinerários ou cancele uma reserva.',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  ro: [
    {
      heading: 'Check-in online',
      subheading: 'Faceți check-in online înainte de a ajunge la aeroport.',
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: 'Gestionați rezervările',
      subheading: 'Vizualizați itinerariile sau anulați o rezervare.',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  pl: [
    {
      heading: 'Odprawa online',
      subheading: 'Odpraw się online przed przybyciem na lotnisko.',
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: 'Zarządzaj rezerwacjami',
      subheading: 'Zobacz swoje trasy lub anuluj rezerwację.',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  lt: [
    {
      heading: 'Registracija internetu',
      subheading: 'Registruokitės internetu prieš atvykdami į oro uostą.',
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: 'Valdykite savo rezervacijas',
      subheading: 'Peržiūrėkite savo maršrutus arba atšaukite rezervaciją.',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  nl: [
    {
      heading: 'Online inchecken',
      subheading: 'Check online in voordat u op de luchthaven aankomt.',
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: 'Beheer uw boekingen',
      subheading: 'Bekijk uw reisroutes of annuleer een boeking.',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  sr: [
    {
      heading: 'Online prijava',
      subheading: 'Prijavite se online pre dolaska na aerodrom.',
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: 'Upravljajte rezervacijama',
      subheading: 'Pregledajte svoje itinerare ili otkažite rezervaciju.',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  uz: [
    {
      heading: "Onlayn ro'yxatdan o'tish",
      subheading: "Aeroportga kelishdan oldin onlayn ro'yxatdan o'ting.",
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: 'Bronlaringizni boshqaring',
      subheading: "Yo'nalishlaringizni ko'ring yoki bronni bekor qiling.",
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  kk: [
    {
      heading: 'Онлайн тіркелу',
      subheading: 'Әуежайға келмес бұрын онлайн тіркеліңіз.',
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: 'Брондауларыңызды басқарыңыз',
      subheading: 'Маршруттарыңызды қараңыз немесе брондауды болдырмаңыз.',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  ky: [
    {
      heading: 'Онлайн каттоо',
      subheading: 'Аэропортко келгенге чейин онлайн каттоодон өтүңүз.',
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: 'Брондооңузду башкаруу',
      subheading: 'Маршруттарыңызды көрүңүз же брондооңузду жокко чыгарыңыз.',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  tg: [
    {
      heading: 'Бақайдгирии онлайн',
      subheading: 'Пеш аз расидан ба фурудгоҳ онлайн бақайд гиред.',
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: 'Идора кардани бронҳои худ',
      subheading: 'Хатсайрҳои худро дида бароед ё брони худро бекор кунед.',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  zh: [
    {
      heading: '在线值机',
      subheading: '在抵达机场之前完成在线值机。',
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: '管理您的预订',
      subheading: '查看您的行程或取消预订。',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  ka: [
    {
      heading: 'ონლაინ რეგისტრაცია',
      subheading: 'გაიარეთ რეგისტრაცია ონლაინ აეროპორტში ჩასვლამდე.',
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: 'ჯავშნების მართვა',
      subheading: 'იხილეთ თქვენი მარშრუტები ან გააუქმეთ ჯავშანი.',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  hi: [
    {
      heading: 'ऑनलाइन चेक-इन',
      subheading: 'हवाई अड्डे पर पहुंचने से पहले ऑनलाइन चेक-इन करें।',
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: 'अपनी बुकिंग प्रबंधित करें',
      subheading: 'अपने यात्रा कार्यक्रम देखें या बुकिंग रद्द करें।',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  ja: [
    {
      heading: 'オンラインチェックイン',
      subheading: '空港に到着する前にオンラインでチェックインしてください。',
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: '予約の管理',
      subheading: '旅程を確認するか、予約をキャンセルしてください。',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  ko: [
    {
      heading: '온라인 체크인',
      subheading: '공항에 도착하기 전에 온라인으로 체크인하세요.',
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: '예약 관리',
      subheading: '여행 일정을 확인하거나 예약을 취소하세요.',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  ur: [
    {
      heading: 'آن لائن چیک ان',
      subheading: 'ہوائی اڈے پر پہنچنے سے پہلے آن لائن چیک ان کریں۔',
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: 'اپنی بکنگ مینیج کریں',
      subheading: 'اپنے سفری منصوبے دیکھیں یا بکنگ منسوخ کریں۔',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  ta: [
    {
      heading: 'ஆன்லைன் செக்-இன்',
      subheading: 'விமான நிலையத்தில் வருவதற்கு முன் ஆன்லைனில் செக்-இன் செய்யுங்கள்.',
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: 'உங்கள் பதிவுகளை நிர்வகிக்கவும்',
      subheading: 'உங்கள் பயண திட்டங்களை பார்க்கவும் அல்லது பதிவை ரத்து செய்யவும்.',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
  th: [
    {
      heading: 'เช็คอินออนไลน์',
      subheading: 'เช็คอินออนไลน์ก่อนเดินทางถึงสนามบิน',
      icon: <Checkin width={40} height={40} />,
      src: '/flights/check-in/',
      isImage: false,
      image: '',
      order: 'row',
      Modal: false,
      isLink: true,
      type: 'onlineCheckIn',
      cursor: 'pointer',
    },
    {
      heading: 'จัดการการจองของคุณ',
      subheading: 'ดูแผนการเดินทางหรือยกเลิกการจอง',
      icon: <PnrSorgu width={40} height={40} />,
      src: '#',
      isImage: false,
      image: '',
      order: 'row',
      Modal: CheckReservationDialog,
      isLink: false,
      type: 'manageYourBookings',
      cursor: 'pointer',
    },
  ],
}
